/**
 * Derives a URL-safe slug from a company name.
 *
 * Runs as the admin types the name so the subdomain is suggested rather than
 * invented — `KPMG LLP` becomes `kpmg-llp`, not `KPMG%20LLP`. The server still
 * validates and owns the reserved list; this only makes the common case
 * effortless.
 *
 * @param name - Company name as typed.
 * @returns A candidate slug, possibly empty for input with no usable characters.
 */
export function slugify(name: string): string {
  return (
    name
      .normalize('NFKD')
      // Strip diacritics so "Zürich" becomes "zurich" rather than losing the u.
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      // Ampersands read as "and" in a hostname far better than being dropped.
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 63)
      // Slicing can leave a trailing hyphen, which is not a valid DNS label.
      .replace(/-+$/, '')
  );
}
